module.exports = __webpack_public_path__ + "static/media/french.f689ce44.svg";